var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attendance-tab-container" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "custom-attendance-tabs",
          attrs: { "tab-position": "top", type: "card" },
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.localTab,
            callback: function ($$v) {
              _vm.localTab = $$v
            },
            expression: "localTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "Lớp", name: "class" } }),
          _c("el-tab-pane", { attrs: { label: "Nhóm", name: "group" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }